import script from "./FooterConnectfn.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterConnectfn.vue?vue&type=script&setup=true&lang=js"

import "./FooterConnectfn.vue?vue&type=style&index=0&id=43b4ac33&lang=css"

const __exports__ = script;

export default __exports__